
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import { LeadType } from '@/types';

@Component
export default class LeadAddChildDialog extends Vue {
  @Prop(Boolean) readonly value!: boolean;

  dialog = false
  loading = false

  childName = 'Lead figlia'
  childType: LeadType = 'elettrica-figlia'

  childTypes: { text: string; value: LeadType }[] = [
    {
      text: 'Lead figlia generica (SA)',
      value: 'installatore-figlia',
    },
    {
      text: 'Lead figlia elettrica',
      value: 'elettrica-figlia',
    },
    {
      text: 'Lead figlia termica',
      value: 'termica-figlia',
    },
  ]

  @Watch('value')
  onValueChange(val: boolean) {
    console.log('LeadAddChildDialog: onValueChange()'); // eslint-disable-line no-console

    this.dialog = val;
  }

  @Watch('dialog')
  onDialogChange(val: boolean) {
    if (this.value !== val) {
      this.$emit('input', val);
    }
  }

  get lead() {
    return this.$store.getters.currentLead;
  }

  // get childCount() {
  //   return this.childTasks && 0 in this.childTasks && this.childTasks[0].childCount
  //     ? this.childTasks[0].childCount : 1;
  // }

  async onCancel() {
    console.log('LeadAddChildDialog: onCancel()'); // eslint-disable-line no-console

    this.dialog = false;
  }

  async onAdd() {
    console.log('LeadAddChildDialog: onRemove()'); // eslint-disable-line no-console

    this.loading = true;

    await this.$store.dispatch('addChild', {
      childName: this.childName || 'Lead figlia',
      childType: this.childType || 'installatore-figlia',
    });

    this.dialog = false;
    setTimeout(() => {
      this.loading = false;
    }, 500);
  }
}
